import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a82a2d02"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "loading-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loadingFive"
}, [/*#__PURE__*/_createElementVNode("span"), /*#__PURE__*/_createElementVNode("span"), /*#__PURE__*/_createElementVNode("span"), /*#__PURE__*/_createElementVNode("span"), /*#__PURE__*/_createElementVNode("span")], -1));
import { reactive } from 'vue';
export default {
  __name: 'loading',
  emits: ['onshow', 'onclose'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const state = reactive({
      loading: {
        text: '正在加载中',
        show: false
      }
    });
    function showLoading(text) {
      state.loading.text = text;
      state.loading.show = true;
      emits("onshow");
    }
    function close() {
      state.loading.show = false;
      emits("onclose");
    }
    function isShow() {
      return state.loading.show;
    }
    __expose({
      showLoading,
      close,
      isShow
    });
    return (_ctx, _cache) => {
      return state.loading.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", null, _toDisplayString(state.loading.text), 1)])) : _createCommentVNode("", true);
    };
  }
};